import { createReducer, on } from '@ngrx/store';

import { setConsentPackageView } from './consent-package-view.actions';

export const consentPackageView = createReducer<boolean>(
  false,
  on(setConsentPackageView, (_, action) => action.payload)
);
